import { WarehouseCheckInAPIService } from "../warehouseCheckInAPIService";
import {
  UnknownArrival,
  GetWarehouseCheckInUnknownArrivalQueryParams,
  PatchWarehouseCheckInUnknownArrivalRequestBody
} from "src/types";

class UnknownArrivalAPIService extends WarehouseCheckInAPIService {
  async getWarehouseCheckInUnknownArrival(
    warehouseCheckInId: string,
    queryParams: GetWarehouseCheckInUnknownArrivalQueryParams
  ): Promise<UnknownArrival> {
    const pathParam = encodeURIComponent(warehouseCheckInId);
    const path = `/${pathParam}/unknown-arrival`;

    return await this.jwtRequest("GET", path, undefined, queryParams);
  }

  async patchWarehouseCheckInUnknownArrivalResolution(
    warehouseCheckInId: string,
    requestBody: PatchWarehouseCheckInUnknownArrivalRequestBody
  ): Promise<UnknownArrival> {
    const pathParam = encodeURIComponent(warehouseCheckInId);
    const path = `/${pathParam}/unknown-arrival/resolution`;

    return await this.jwtRequest("PATCH", path, requestBody);
  }
}

export { UnknownArrivalAPIService };
